import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "./App.css";
import "./i18n";
import AuthContextProvider from "./context/AuthContext"; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthContextProvider> 
      <App />
    </AuthContextProvider>
  </React.StrictMode>
);
